<nav
  #navbar
  [ngClass]="{ scroll, 'hidden': !navbar_hidden, 'modeMini': url !== '' }"
  [ngStyle]="{ '--navbar-height': navbar_height + 'px' }"
>
  <div class="content">
    <a class="logo" routerLink="/">
      <!--<img
        *ngIf="url === ''"
        title="logo"
        src="../../../assets/logo/logo-poster.png"
        class="logo_poster"
      />-->
      <img
        *ngIf="url === '' && !navbar_hidden"
        title="logo"
        src="../../../assets/logo/logo_site.png"
        class="logo"
      />
      <img
        *ngIf="url === '' && scroll"
        title="logo"
        src="../../../assets/logo/logo_site.png"
        class="mini"
      />
      <img
        *ngIf="url === '' && !scroll"
        title="logo"
        src="../../../assets/logo/logo_site.png"
        class="logo"
      />
      <img
        *ngIf="url !== ''"
        title="logo"
        src="../../../assets/logo/wv_home.png"
        class="mini"
      />
    </a>

    <div class="hamburger" [ngClass]="{ active: !navbar_hidden }" #navClick>
      <button
        aria-label="menu"
        mat-icon-button
        (click)="navbar_hidden = !navbar_hidden"
      >
        <span class="line"></span>
      </button>
    </div>

    <div class="menu {{ colapse }}" [ngClass]="{ hidden: navbar_hidden }">
      <!-- <a mat-button class="f-16" routerLinkActive="active" routerLink="/about"
        >Sobre</a
      >
      <a mat-button class="f-16" routerLinkActive="active" routerLink="/news"
        >Notícias</a
      > -->
      <!-- <a
        mat-button
        class="f-16"
        *ngIf="user?.id"
        routerLinkActive="active"
        routerLink="/possessions"
        >Posses</a
      > -->
      <a
        mat-button
        class="f-16"
        routerLinkActive="active"
        routerLink="/auction-schedule"
        (click)="navbar_hidden = true"
        >Agenda de Eventos</a
      >
      <a
        mat-button
        class="f-16"
        routerLinkActive="active"
        routerLink="/streaming"
        (click)="navbar_hidden = true"
        >Transmissão</a
      >
      <a
        mat-button
        class="f-16"
        routerLinkActive="active"
        routerLink="/contact"
        (click)="navbar_hidden = true"
        >Contato</a
      >
      <a
        *ngIf="!user?.id"
        mat-button
        class="f-16"
        routerLinkActive="active"
        routerLink="/register"
        >Cadastro</a
      >
      <button
        *ngIf="url !== 'login' && !user?.id"
        mat-button
        type="submit"
        routerLink="/login"
        class="primary"
        (click)="navbar_hidden = true"
      >
        Login
      </button>

      <a
        *ngIf="user?.name"
        class="f-16 default"
        routerLinkActive="active"
        routerLink="/profile"
        (click)="navbar_hidden = true"
        >Bem vindo(a), {{ user.name }}</a
      >

      <button
        title="profile"
        *ngIf="user?.id"
        routerLink="/profile"
        class="picture"
        (click)="navbar_hidden = true"
      >
        <img *ngIf="user.profile_image" [src]="user.profile_image" alt="" />
        <img
          *ngIf="!user.profile_image"
          src="../../../assets/images/GetPhoto.png"
          alt=""
        />
      </button>

      <!-- <button title="notification" class="btn-icon-notification"  mat-icon-button [matMenuTriggerFor]="menuNotification">
          <i matBadge="2" matBadgeColor="warn" icon="notification"></i>
        </button>

        <mat-menu #menuNotification="matMenu">
          <button class="menu-notification" mat-menu-item>
            <a>Seu lance foi negado !</a>
          </button>
          <button class="menu-notification" mat-menu-item>
            <a>Seu lance foi negado !</a>
          </button>
        </mat-menu> -->

      <a *ngIf="user?.id" mat-button (click)="logout()">Sair</a>
    </div>
  </div>
</nav>

<div
  class="card_bids"
  (click)="openPopupBids()"
  *ngIf="!loading && url !== 'login'"
>
  <!-- <div class="card_bids" (click)="openComparingJourneys()"> -->
  <img
    title="image"
    *ngIf="isStatus === 'AGUARDANDO'"
    src="../../../assets/images/lance_processando.png"
  />
  <img
    title="image"
    *ngIf="['RECUSADO', 'SUPERADO'].includes(isStatus)"
    src="../../../assets/images/lance_superado.png"
  />
  <img
    title="image"
    *ngIf="isStatus === 'ACEITO'"
    src="../../../assets/images/lance_vencendo.png"
  />
  <img
    title="image"
    *ngIf="isStatus === ''"
    src="../../../assets/images/sem_lance.png"
  />
</div>

<router-outlet *ngIf="!loading" #outlet="outlet"></router-outlet>

<page-loading *ngIf="loading"></page-loading>
